import service from "../../util/http";

// 查询已办任务列表
export function finishedList(query) {
  return service({
    url: '/manage/flowable/task/finishedList',
    method: 'get',
    params: query
  })
}

// 任务流转记录
export function flowRecord(query) {
  return service({
    url: '/manage/flowable/task/flowRecord',
    method: 'get',
    params: query
  })
}

// 部署流程实例
export function deployStart(deployId) {
  return service({
    url: '/manage/flowable/process/startFlow/' + deployId,
    method: 'get',
  })
}

// 查询流程定义详细
export function getDeployment(id) {
  return service({
    url: '/manage/system/deployment/' + id,
    method: 'get'
  })
}

// 新增流程定义
export function addDeployment(data) {
  return service({
    url: '/manage/system/deployment',
    method: 'post',
    data: data
  })
}

// 修改流程定义
export function updateDeployment(data) {
  return service({
    url: '/manage/system/deployment',
    method: 'put',
    data: data
  })
}

// 删除流程定义
export function delDeployment(id) {
  return service({
    url: '/manage/flowable/instance/delete/' + id,
    method: 'delete'
  })
}

// 导出流程定义
export function exportDeployment(query) {
  return service({
    url: '/manage/system/deployment/export',
    method: 'get',
    params: query
  })
}
